module.exports = __webpack_public_path__ + "img/illustration.e15fcbf5.svg";